/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Settings_Reasoning_Desc_XhighInputs */



/**
* | output |
* | --- |
* | "Extended reasoning for demanding coding and agentic work." |
*
* @param {Model_Settings_Reasoning_Desc_XhighInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_settings_reasoning_desc_xhigh = /** @type {((inputs?: Model_Settings_Reasoning_Desc_XhighInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Settings_Reasoning_Desc_XhighInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erweiterte Begründung für anspruchsvolle Programmier- und Agentenaufgaben.")
	return /** @type {LocalizedString} */ ("Extended reasoning for demanding coding and agentic work.")
});